export const scope = {
  ACCOUNT_READ: 'account:read',
  BILLING_READ: 'billing:read',
  CLIENT_AGREE_TERMS: 'client:agree_terms',
  CLIENT_CREATE: 'client:create',
  CLIENT_EDIT: 'client:edit',
  CLIENT_DELETE: 'client:delete',
  CLIENT_READ: 'client:read',
  CLIENT_STAR: 'client:star',
  IMPORT_REQUEST_TOGGLE_REMINDERS: 'import_request:toggle_reminders',
  IMPORT_REQUEST_READ: 'import_request:read',
  IMPORT_REQUEST_WRITE: 'import_request:write',
  PAYMENT_METHOD_WRITE: 'payment_method:write',
  POST_IMPORT_CREATE: 'post_import:create',
  POST_IMPORT_READ: 'post_import:read',
  POST_MONITOR: 'post:monitor',
  POST_READ: 'post:read',
  POST_RESOLVE: 'post:resolve',
  POST_SEARCH_READ: 'post_search:read',
  POST_SEARCH_WRITE: 'post_search:write',
  POST_WRITE: 'post:write',
  REPORT_READ: 'report:read',
  REPORT_WRITE: 'report:write',
  ROLE_READ: 'role:read',
  SERVICE_ACCOUNT_READ: 'service_account:read',
  SOCIAL_ACCOUNT_CREATE: 'social_account:create',
  SOCIAL_ACCOUNT_DELETE: 'social_account:delete',
  SOCIAL_ACCOUNT_READ: 'social_account:read',
  SOCIAL_ACCOUNT_RECONNECT: 'social_account:reconnect',
  USER_CLIENT_READ: 'user_client:read',
  USER_CLIENT_WRITE: 'user_client:write',
  USER_DELETE: 'user:delete',
  USER_EDIT: 'user:edit',
  USER_INVITE: 'user:invite',
  USER_NOTIFICATION_WRITE: 'user_notification:write',
  USER_READ: 'user:read',
  USER_RESEND_INVITE: 'user:resend_invite',
  ANALYSIS_FACES_READ: 'analysis:faces:read',
  ANALYSIS_FACES_WRITE: 'analysis:faces:write',
  ANALYSIS_LABELS_READ: 'analysis:labels:read',
};
